<template>
  <div class="text-dark mx-auto mt-10" style="width: 1000px">
    <div class="text-center">
      <div class="mb-1" style="font-size: 26px">
        {{ $t('frontend_builder_form') }}
        {{ $t('frontend_groovemail_contact_tabs_forms_optin_settings') }}
      </div>
      <div class="text-base" style="color: #696b83">
        {{ $t('frontend_groovemail_forms_step4_youcan') }}
      </div>
    </div>
    <div class="relative w-full flex flex-col">
      <div
        class="flex flex-row w-full mb-10"
        style="color: #989ab2; border-bottom: 1px solid #dcdcea"
      >
        <gd-tabs
          class="forms-configure-step-tabs"
          :tabs="tabs"
          :current-tab="currentTab"
          :wrapper-class="'pt-10 gs-default-tabs'"
          :tab-class="mainTabClass"
          :tab-active-class="'border-primary border-b-2 text-primary gs-default-tabs-item-active'"
          :line-class="'gs-default-tabs-active-line'"
          @onClick="handleTabChange"
        />
      </div>
    </div>
    <div
      id="form-name"
      class="form-content-box p-10 mb-20"
      v-if="this.$route.name === 'EditForm'"
    >
      <div class="font-semibold mb-2">
        {{ $t('frontend_groovemail_admin_forms_form_name') }}
      </div>
      <div style="width: 400px">
        <text-input
          variant="base"
          v-model="localModel.name"
          :placeholder="this.$t('frontend_groovemail_adminsetting_name')"
          :validator="$v.localModel.name"
        />
      </div>
    </div>
    <step4
      ref="step4"
      @showLoader="showLoader"
      @hideLoader="hideLoader"
      @requestErrorAlert="requestErrorAlert"
      :model="localModel"
      @updateModel="localModel = $event"
      @dataValid="listTagDataValid"
    ></step4>
    <step2
      ref="step2"
      @showLoader="showLoader"
      @hideLoader="hideLoader"
      :model="localModel"
      @openCreateEmailSenderModal="openCreateEmailSenderModal"
      @openCreateSmsSenderModal="openCreateSmsSenderModal"
      @updateModel="localModel = $event"
      @saveOnEmailContentReset="saveOnEmailContentReset"
      @openConfirmPreview="showContentPreview"
      @fetchTemplates="fetchEmailTemplates"
    ></step2>
    <step3
      ref="step3"
      @showLoader="showLoader"
      @hideLoader="hideLoader"
      :model="localModel"
      @openCreateEmailSenderModal="openCreateEmailSenderModal"
      @openCreateSmsSenderModal="openCreateSmsSenderModal"
      @updateModel="localModel = $event"
      @saveOnEmailContentReset="saveOnEmailContentReset"
      @openWelcomePreview="showContentPreview"
      @fetchTemplates="fetchEmailTemplates"
    ></step3>

    <gd-modal
      id="create-email-sender-wrapper"
      name="create-email-sender-modal"
      :title="$t('frontend_groovemail_settings_sender_settings')"
    >
      <VuePerfectScrollbar>
        <div class="scroll-modal-tab">
          <create-email-sender
            ref="createEmailSender"
            @emailSenderCreated="emailSenderCreated"
          >
          </create-email-sender>
          <div class="flex justify-end p-6 pt-0">
            <gd-button
              size="auto"
              @click="closeCreateEmailSenderModal"
              >{{ $t('frontend_cancel') }}</gd-button
            >
            <gd-button
              variant="primary"
              size="auto"
              @click="createNewEmailSender"
              class="ml-2 new-add-btn"
            >
              {{ $t('frontend_groovemail_create_sender_route_page_title') }}
            </gd-button>
          </div>
        </div>
      </VuePerfectScrollbar>
    </gd-modal>

    <gd-modal
      id="create-sms-sender-wrapper"
      name="create-sms-sender-modal"
      :title="$t('frontend_groovemail_settings_integeration_settings')"
    >
      <VuePerfectScrollbar>
        <div class="scroll-modal-tab">
          <create-sms-sender
            ref="createSmsSender"
            @smsSenderCreated="smsSenderCreated"
          >
          </create-sms-sender>
          <div class="flex justify-end p-6 pt-0">
            <gd-button
              size="auto"
              @click="closeCreateSmsSenderModal"
              >{{ $t('frontend_cancel') }}</gd-button
            >
            <gd-button
              variant="primary"
              @click="createNewSmsSender"
              size="auto"
              class="ml-2"
              >{{
                $t('frontend_groovemail_create_sender_route_page_title')
              }}</gd-button
            >
          </div>
        </div>
      </VuePerfectScrollbar>
    </gd-modal>

    <gd-modal
      id="show-emailpreview-modal"
      width="80%"
      height="100%"
      name="form-email-preview-modal"
      :title="$t('frontend_preview')"
    >
      <VuePerfectScrollbar>
        <div class="w-full p-6" style="height: calc(100vh - 115px)">
          <div
            v-shadow
          >
            <div
              class="pb-6"
              v-html="showUnsubscribeText
                ? previewContent +
                `<p style='margin: 0px'><br></p>` +
                unsubscribeContent
                : previewContent
              "
            ></div>
          </div>
        </div>
      </VuePerfectScrollbar>
    </gd-modal>

    <gd-modal
      id="campaign-message-wrapper"
      name="form-sms-preview-modal"
      :title="`${$t('frontend_preview')} ${$t('frontend_groovemail_campains_show_message')}`"
    >
      <VuePerfectScrollbar>
        <campaign-preview
          class="p-6"
          :campaignMethod="contentType"
          :campaignMessage="previewContent"
        ></campaign-preview
      ></VuePerfectScrollbar>
    </gd-modal>

    <gd-modal
      name="forms-email-templates-modal"
      class="gm-befree-email-templates-modal"
      width="95vw"
      height="95vh"
      :title="$t('frontend_groovemail_modal_email_template_header')"
    >
      <div
        class="w-full py-4"
        style="max-height: calc(100vh - 90px); min-height: 70vh"
      >
        <template-container
          filtersHeight="calc(100vh - 260px)"
          templatesHeight="calc(100vh - 120px)"
          @selectedTemplate="selectThisTemplate"
        ></template-container>
      </div>
    </gd-modal>
  </div>
</template>

<script>
import axios from 'axios';
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import step2 from './step2';
import step3 from './step3';
import step4 from './step4';

import CampaignPreview from "../campaigns/campaign-preview.vue";
import CreateEmailSender from '../settings/create.vue';
import CreateSmsSender from '../settings/create_integeration.vue';
import TemplateContainer from '@/components/befree-email-builder/template-container.vue';


import showAlert from '@/components/sweet-alert-popup.js';
import themeConfig from '@/theme/themeConfig.js';

export default {
  name: 'Step2main',
  props: {
    model: {
      required: true,
    },
  },

  data() {
    return {
      changesMadeInStep: false,
      localModel: this.model,
      currentTab: '',
      currentEmailSenderCreationType: '',
      currentSmsSenderCreationType: '',
      unsubscribeContent: '',
      contentType: 'email',
      previewContent: '',
      emailTemplateFor: '',
      editorTypeEmailBuilder: false,
      showUnsubscribeText: false,
    };
  },

  components: {
    step2,
    step3,
    step4,
    CreateEmailSender,
    VuePerfectScrollbar,
    CreateSmsSender,
    CampaignPreview,
    TemplateContainer,
  },

  validations: {
    localModel: {
      name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(50),
      },
    },
  },

  computed: {
    tabs() {
      const tabs = [];
      if (this.$route.name === 'EditForm') {
        tabs.push({
          title: `<span class="text-sm">${this.$t('frontend_groovemail_admin_forms_form_name')} <span>`,
          value: 'form-name',
        });
      }
      tabs.push({
        title: `<span class="text-sm"> ${this.$t('frontend_groovemail_forms_step4_subscribe')} <span>`,
        value: 'subscriber-list',
      });
      tabs.push({
        title: `<span class="text-sm"> ${this.$t('frontend_groovemail_forms_step4_assigntags')} <span>`,
        value: 'assign-tags',
      });
      tabs.push({
        title: `<span class="text-sm"> ${this.$t('frontend_groovemail_sequences_route_page_title')} <span>`,
        value: 'sequence-list',
      });
      tabs.push({
        title: `<span class="text-sm"> ${this.$t('frontend_groovemail_forms_step2_optin_setting_tab_header')} <span>`,
        value: 'optin-settings',
      });
      tabs.push({
        title: `<span class="text-sm"> ${this.$t('frontend_groovemail_forms_step2_success')} <span>`,
        value: 'success-message',
      });
      tabs.push({
        title: `<span class="text-sm"> ${this.$t('frontend_groovemail_forms_step2_welcome_setting_tab_header')} <span>`,
        value: 'welcome-settings',
      });
      tabs.push({
        title: `<span class="text-sm"> ${this.$t('frontend_groovemail_forms_step3_forward_responses')} <span>`,
        value: 'recipients',
      });

      return tabs;
    },
    mainTabClass() {
      return 'pb-4 gs-default-tabs-item';
    },
  },

  watch: {
    localModel() {
      this.$emit('updateModel', this.localModel);
    },

    // Watch for changes to the 'name' property in 'localModel'
    'localModel.name': function localModelNameWatcher() {
      this.handleLocalModelChange();
    },

    // Watch for changes to the 'optin' property in 'localModel'
    'localModel.optin': function localModelOptinWatcher() {
      this.handleLocalModelChange();
    },

    // Watch for changes to the 'confirmlink_sendoption' property in 'localModel'
    'localModel.confirmlink_sendoption': function localModelConfirmlinkSendoptionWatcher() {
      this.handleLocalModelChange();
    },

    // Watch for changes to the 'confirmlink_subject' property in 'localModel'
    'localModel.confirmlink_subject': function localModelConfirmlinkSubjectWatcher() {
      this.handleLocalModelChange();
    },

    // Watch for changes to the 'confirmlink_pageurl' property in 'localModel'
    'localModel.confirmlink_pageurl': function localModelConfirmlinkPageurlWatcher() {
      this.handleLocalModelChange();
    },

    // Watch for changes to the 'success_pageurl' property in 'localModel'
    'localModel.success_pageurl': function localModelSuccessPageurlWatcher() {
      this.handleLocalModelChange();
    },

    // Watch for changes to the 'confirmlink_content' property in 'localModel'
    'localModel.confirmlink_content': function localModelConfirmlinkContentWatcher() {
      this.handleLocalModelChange();
    },

    // Watch for changes to the 'confirmlink_sender_id' property in 'localModel'
    'localModel.confirmlink_sender_id': function localModelConfirmlinkSenderIdWatcher() {
      this.handleLocalModelChange();
    },

    // Watch for changes to the 'confirmlink_sms_content' property in 'localModel'
    'localModel.confirmlink_sms_content': function localModelConfirmlinkSmsContentWatcher() {
      this.handleLocalModelChange();
    },

    // Watch for changes to the 'welcome_msg_option' property in 'localModel'
    'localModel.welcome_msg_option': function localModelWelcomeMsgOptionWatcher() {
      this.handleLocalModelChange();
    },

    // Watch for changes to the 'welcome_msg_subject' property in 'localModel'
    'localModel.welcome_msg_subject': function localModelWelcomeMsgSubjectWatcher() {
      this.handleLocalModelChange();
    },

    // Watch for changes to the 'welcome_sender_id' property in 'localModel'
    'localModel.welcome_sender_id': function localModelWelcomeSenderIdWatcher() {
      this.handleLocalModelChange();
    },

    // Watch for changes to the 'welcome_msg_content' property in 'localModel'
    'localModel.welcome_msg_content': function localModelWelcomeMsgContentWatcher() {
      this.handleLocalModelChange();
    },

    // Watch for changes to the 'welcome_msg_sms_content' property in 'localModel'
    'localModel.welcome_msg_sms_content': function localModelWelcomeMsgSmsContentWatcher() {
      this.handleLocalModelChange();
    },

    // Watch for changes to the 'assignlists' property in 'localModel'
    'localModel.assignlists': function localModelAssignlistsWatcher() {
      this.handleLocalModelChange();
    },
  },

  async created() {
    if (this.$route.name === 'EditForm') {
      this.currentTab = 'form-name';
    } else {
      this.currentTab = 'subscriber-list';
    }
  },

  methods: {
    // Method to handle changes to the 'localModel' property
    handleLocalModelChange() {
      // Set the 'changesMadeInStep' flag to true
      this.changesMadeInStep = true;
      // Call the 'checkStep2Validity' method to check the validity of the current step
      this.checkStep2Validity();
    },

    // Method to check the validity of the current step
    checkStep2Validity() {
      const step4validity = this.$refs.step4.validateBeforeSubmit();
      const listTagValid = step4validity.isValid;
      this.$emit(
        'stepValidity',
        this.step2subStepsValid(false) &&
          Boolean(listTagValid) &&
          !this.$v.localModel.name.$invalid,
        'step2'
      );
    },

    checkChangesMadeOnThisStep() {
      return this.changesMadeInStep;
    },

    showLoader() {
      this.$emit('showLoader');
    },

    hideLoader() {
      this.$emit('hideLoader');
    },



    // error message for the request field
    async requestErrorAlert(error) {
      // hide the loader
      this.hideLoader();
      
      await showAlert({
        iconType: 'alert-error',
        html : `
          <style>.swal2-cancel { color: ${themeConfig.appPrimaryColorInvert} !important; }</style>
          <p class="text-sm text-deep-dark mb-3">${error || this.$t('frontend_backend_error') }</p>
        `,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonColor: themeConfig.appPrimaryColor,
        confirmButtonText: this.$t('frontend_close'),
      });
    },

    async showContentPreview(previewData, showUnsubscribeText, editorTypeBuilder) {
      this.editorTypeEmailBuilder = editorTypeBuilder;
      this.showLoader();
      try {
        const unsubscribeData = await axios.get(
          '/setting/get-unsubscribe-layout'
        );
        this.unsubscribeContent = unsubscribeData.data.footer_layout;
      } catch (error) {
        // show error message
        this.requestErrorAlert(error.response?.data?.error);
      }
      this.previewContent = previewData.previewContent;
      this.contentType = previewData.contentType;
      if (this.contentType === 'email') {
        this.showUnsubscribeText = showUnsubscribeText;
        this.$root.$emit('modal-open', 'form-email-preview-modal');
      } else if (this.contentType === 'sms') {
        this.$root.$emit('modal-open', 'form-sms-preview-modal');
      }
      this.hideLoader();
    },

    listTagDataValid(isValid) {
      this.$emit(
        'stepValidity',
        this.step2subStepsValid(false) &&
          Boolean(isValid) &&
          !this.$v.localModel.name.$invalid,
        'step2'
      );
    },

    openCreateEmailSenderModal(senderCreation) {
      this.currentEmailSenderCreationType = senderCreation.type;
      this.$root.$emit('modal-open', 'create-email-sender-modal');
    },

    closeCreateEmailSenderModal() {
      this.$root.$emit('modal-close', 'create-email-sender-modal');
    },

    async createNewSmsSender() {
      await this.$refs.createSmsSender.createNewSmsSender();
    },

    async emailSenderCreated(senderData) {
      this.showLoader();
      await this.$refs.step2.emailSenderCreated(
        senderData,
        this.currentEmailSenderCreationType === 1
      );
      await this.$refs.step3.emailSenderCreated(
        senderData,
        this.currentEmailSenderCreationType === 2
      );
      this.$root.$emit('modal-close', 'create-email-sender-modal');
      this.hideLoader();
    },

    openCreateSmsSenderModal(senderCreation) {
      this.currentSmsSenderCreationType = senderCreation.type;
      this.$root.$emit('modal-open', 'create-sms-sender-modal');
    },

    closeCreateSmsSenderModal() {
      this.$root.$emit('modal-close', 'create-sms-sender-modal');
    },

    async createNewEmailSender() {
      // show loader
      this.showLoader();

      try {
        // create new email sender
        await this.$refs.createEmailSender.createNewSender();
      } catch (error) {
        // show error message
        this.requestErrorAlert(error.response?.data?.error);
      }
    },

    async smsSenderCreated(senderData) {
      // show loader
      this.showLoader();

      try {
        // create new sms sender
        await this.$refs.step2.smsSenderCreated(
          senderData,
          this.currentSmsSenderCreationType === 1
        );
        await this.$refs.step3.smsSenderCreated(
          senderData,
          this.currentSmsSenderCreationType === 2
        );
        this.$root.$emit('modal-close', 'create-sms-sender-modal');
        
        // hide loader
        this.hideLoader();
      } catch (error) {
        // show error message
        this.requestErrorAlert(error.response?.data?.error);
      }
    },

    /**
     * Validates the sub-steps of step 2 and returns whether step 2 is valid.
     * If scrollToInvalidSection is true, scrolls to the first invalid section.
     * 
     * @param {boolean} scrollToInvalidSection - Whether to scroll to the first invalid section.
     * @returns {boolean} - Whether step 2 is valid.
    */
    step2subStepsValid(scrollToInvalidSection) {
      // If the current route is 'EditForm', touch the 'name' field to trigger validation
      if (this.$route.name === 'EditForm') {
        this.$v.localModel.name.$touch();
      }

      // Validate step 4 (list and tag selection)
      const step4validity = scrollToInvalidSection
        ? this.$refs.step4.validate()
        : this.$refs.step4.validateBeforeSubmit();
      const listTagValid = step4validity.isValid;

      // Validate step 3 (welcome message settings)
      const welcomeStepValid = scrollToInvalidSection
        ? this.$refs.step3.validate()
        : this.$refs.step3.validateBeforeSubmit();

      // Validate step 2 (opt-in settings)
      const optinStepValid = scrollToInvalidSection
        ? this.$refs.step2.validate()
        : this.$refs.step2.validateBeforeSubmit();

      // Check if step 2 is valid
      let step2Valid = false;
      if (this.$route.name === 'EditForm') {
        step2Valid =
          listTagValid &&
          welcomeStepValid &&
          optinStepValid &&
          !this.$v.localModel.name.$invalid;
      } else {
        step2Valid = listTagValid && welcomeStepValid && optinStepValid;
      }

      // Scroll to the first invalid section (if scrollToInvalidSection is true)
      if (scrollToInvalidSection) {
        if (this.$v.localModel.name.$invalid) {
          // Scroll to the 'name' field
          this.scrollToElement('form-name');
        } else if (!listTagValid) {
          if (
            !this.localModel.assignlists || (this.localModel.assignlists && this.localModel.assignlists.length <= 0)
          ) {
            // Scroll to the 'subscriber-list' field
            this.scrollToElement('subscriber-list');
          } else if (
            step4validity.customModel.tagassigned === 'yes' &&
            (!this.localModel.assigntags || (this.localModel.assigntags &&this.localModel.assigntags.length <= 0))
          ) {
            // Scroll to the 'assign-tags' field
            this.scrollToElement('assign-tags');
          } else if (
            step4validity.customModel.sequenceassigned === 'yes' &&
            (!this.localModel.assignsequences || (this.localModel.assignsequences && this.localModel.assignsequences.length <= 0))
          ) {
            // Scroll to the 'sequence-list' field
            this.scrollToElement('sequence-list');
          }
        } else if (!this.localModel.success_pageurl || this.checkSuccessUrlInvalid()) {
          // Scroll to the 'success-message' field
          this.scrollToElement('success-message');
        } else if (!optinStepValid) {
          // Scroll to the 'optin-settings' field
          this.scrollToElement('optin-settings');
        } else if (!welcomeStepValid) {
          // Scroll to the 'welcome-settings' field
          this.scrollToElement('welcome-settings');
        }
      }

      // Return whether step 2 is valid
      return step2Valid;
    },

    // Method to scroll to a particular element
    scrollToElement(elementId) {
      const selectedId = document.getElementById(elementId);
      selectedId.scrollIntoView();
    },

    validateForSaveAndExit() {
      return this.step2subStepsValid(true);
    },

    validate() {
      const isValid = this.step2subStepsValid(true);
      this.$emit('on-validate', isValid);
      return isValid;
    },

    handleTabChange(stepId) {
      this.currentTab = stepId;
      const selectedId = document.getElementById(stepId);
      selectedId.scrollIntoView();
    },

    checkSuccessUrlInvalid() {
      return this.$refs.step2.isSuccessUrlInvalid();
    },

    saveOnEmailContentReset() {
      this.$emit('saveOnEmailContentReset');
    },

    fetchEmailTemplates(templateFrom) {
      this.emailTemplateFor = templateFrom;
      this.$root.$emit('modal-open', 'forms-email-templates-modal');
    },

    selectThisTemplate(templateId, templateType) {
      if (this.emailTemplateFor === 1) {
        this.$refs.step2.assignTemplateDataInBuilder(templateId, templateType);
      } else if (this.emailTemplateFor === 2) {
        this.$refs.step3.assignTemplateDataInBuilder(templateId, templateType);
      }
      this.$root.$emit('modal-close', 'forms-email-templates-modal');
    },
  },
};
</script>

<style lang="scss">
.forms-configure-step-tabs {
  .tabs__item {
    padding-bottom: 3px;
    text-align: left;
    margin-right: 24px;
  }
  .tabs__item_active {
    font-weight: bold;
    position: relative;
    border: none;
    &::before {
      width: 100%;
      height: 2px;
      display: inline-block;
      content: '';
      background: var(--brand-primary);
      position: absolute;
      bottom: -1px;
      left: 0;
    }
  }
  span.text-sm {
    .fa-check,
    .fa-chevron-right {
      display: none;
    }
  }
}
</style>
